import React from "react";

export function TableHeader(props: { columns: JSX.Element[], className: string }) {
    return (<thead className={props.className}>
    <tr>
        {props.columns.map((column) => column)}
    </tr>
    </thead>);
}